import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'

import rootSaga from './saga/saga.js'
import accountReducer from './reducers/accountReducer'
import generalReducer from './reducers/generalReducer'
import studentReducer from './reducers/studentReducer'

const sagaMiddleware = createSagaMiddleware()

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  combineReducers({
    account: accountReducer,
    general: generalReducer,
    student: studentReducer,
  }),
  composeEnhancers(
    applyMiddleware(
      sagaMiddleware
    )
  )
)

sagaMiddleware.run(rootSaga)

export default store